import { SectionMark } from "@/components/section-mark";
import { FaqDetails } from "@/components/faq-details";
import { faqItems } from "@/content/site-content";

export function FaqSection() {
  return (
    <section
      id="faq"
      aria-labelledby="faq-heading"
      className="content-visibility-auto border-b border-ink/10 bg-surface"
    >
      <div className="container-page section-pad">
        <SectionMark number="12" label="Najczęstsze pytania" />
        <div className="mt-7 grid gap-8 md:grid-cols-[0.42fr_1fr] md:gap-12">
          <h2 id="faq-heading" className="display-xl text-[1.9rem] md:text-[2.4rem]">
            Zanim napiszesz
          </h2>
          <FaqDetails items={faqItems} />
        </div>
      </div>
    </section>
  );
}
